var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecurityalerts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 70,
    viewBox: "0 0 64 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.4661 8.03284H10.5338C5.3473 8.03284 1.14282 12.1764 1.14282 17.2877V59.5977C1.14282 64.709 5.3473 68.8525 10.5338 68.8525H53.4661C58.6526 68.8525 62.8571 64.709 62.8571 59.5977V17.2877C62.8571 12.1764 58.6526 8.03284 53.4661 8.03284Z",
    fill: "white",
    stroke: "#09090B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2151 30.9686H17.7769V55.2831H46.2151V30.9686Z",
    stroke: "#09090B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7554 30.9687V26.1263C22.7637 23.68 23.7396 21.3362 25.47 19.6064C27.2004 17.8766 29.545 16.901 31.9921 16.8927V16.8927C34.4351 16.9073 36.7736 17.8856 38.4989 19.6147C40.2242 21.3439 41.1968 23.6841 41.2051 26.1263V30.9687",
    stroke: "#09090B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32 49.3443C34.5247 49.3443 36.5714 47.2892 36.5714 44.7541C36.5714 42.219 34.5247 40.1639 32 40.1639C29.4753 40.1639 27.4286 42.219 27.4286 44.7541C27.4286 47.2892 29.4753 49.3443 32 49.3443Z",
    fill: "#DD44B9",
    stroke: "#09090B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2599 14.3375C50.5865 14.3375 53.2832 11.6417 53.2832 8.31629C53.2832 4.99085 50.5865 2.29504 47.2599 2.29504C43.9334 2.29504 41.2367 4.99085 41.2367 8.31629C41.2367 11.6417 43.9334 14.3375 47.2599 14.3375Z",
    fill: "#DD44B9",
    stroke: "#09090B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityalerts);
export default __webpack_public_path__ + "static/media/securityalerts.658ae798a344a348c807babb5c1bcf5b.svg";
export { ForwardRef as ReactComponent };